import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = 'Photon Energy Calculator';
const DESCRIPTION = 'The Photon Energy Calculator calculates photon energy based on photon frequency and Planck\'s constant.';
const KEYWORDS = 'Photon energy, Calculate photon energy, Photon energy calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/photonenergy';
function PhotonEnergyCalculator() {
    const [frequency, setFrequency] = useState('');
    const [photonEnergy, setPhotonEnergy] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!frequency) {
            setError('Please enter the photon frequency correctly');
            setPhotonEnergy('');
            return;
        }
        const frequencyValue = parseFloat(frequency);
        if (isNaN(frequencyValue) || frequencyValue <= 0) {
            setError('Please enter a valid and positive value for photon frequency');
            setPhotonEnergy('');
            return;
        }
        const planckConstant = 6.626e-34;
        const photonEnergyValue = (planckConstant * frequencyValue).toPrecision(2);
        setPhotonEnergy(photonEnergyValue);
        setError('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>How to Calculate Photon Energy</h2>
                                <p>
                                    Photon energy can be calculated based on photon frequency using the following formula:
                                </p>
                                <p>
                                    Photon Energy (E) = Planck's Constant (h) × Photon Frequency (ν)
                                </p>
                                <p>
                                    Please enter the photon frequency to calculate photon energy.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="ltr">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">Photon Frequency (Hertz)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="2.5e14"
                                                value={frequency}
                                                onChange={(e) => setFrequency(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            Calculate Photon Energy
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                        ) : (
                                            <>
                                                {photonEnergy !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        Photon Energy (Joules): {photonEnergy} Joules
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
        </div>
    );
}
export default PhotonEnergyCalculator;
